"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auStateValidation = exports.postalAddressStyleValidation = exports.residentialStatusValidation = exports.streetTypeValidation = exports.poBoxValidation = exports.postcodeAddressValidation = exports.propertyNameValidation = exports.cityAddressValidation = exports.suburbAddressValidation = exports.streetNameAddressValidation = exports.streetNumberAddressValidation = exports.unitAddressValidation = void 0;
var unitAddressRegex = RegExp('^[0-9]+[a-zA-Z]*$');
var streetNumberAddressRegex = RegExp('^[A-Za-z0-9/-]*$');
var streetNameAddressRegex = RegExp('^[A-Za-z ]*$');
var suburbAddressRegex = RegExp("^[A-Za-z '-]*$");
var cityAddressRegex = RegExp("^[A-Za-z '-]*$");
var postcodeAddressRegex = RegExp('^[0-9]{4}$');
var poBoxRegex = RegExp("^[A-Za-z0-9/'-@]*$");

function validate(minLength, maxLength, regex, invalidMessage) {
  return function (value) {
    var _value$trim = value.trim(),
        length = _value$trim.length;

    if (length < minLength) {
      return "Must have at least ".concat(minLength, " characters");
    }

    if (length > maxLength) {
      return "Must have at most ".concat(maxLength, " characters");
    }

    if (!regex.test(value)) {
      return invalidMessage;
    }

    return null;
  };
}

function validatePostcode(length, regex, invalidMessage) {
  return function (value) {
    var stringLength = value.trim().length;

    if (stringLength !== length) {
      return "Must have ".concat(length, " characters");
    }

    if (!regex.test(value)) {
      return invalidMessage;
    }

    return null;
  };
}

function validateSelect(invalidMessage) {
  return function (value) {
    var stringLength = value.trim().length;

    if (stringLength === 0) {
      return invalidMessage;
    }

    return null;
  };
}

var unitAddressValidation = validate(1, 6, unitAddressRegex, 'Invalid unit number', true);
exports.unitAddressValidation = unitAddressValidation;
var streetNumberAddressValidation = validate(1, 6, streetNumberAddressRegex, 'Invalid Street number');
exports.streetNumberAddressValidation = streetNumberAddressValidation;
var streetNameAddressValidation = validate(1, 15, streetNameAddressRegex, 'Invalid Street name');
exports.streetNameAddressValidation = streetNameAddressValidation;
var suburbAddressValidation = validate(1, 30, suburbAddressRegex, 'Invalid Suburb', true);
exports.suburbAddressValidation = suburbAddressValidation;
var cityAddressValidation = validate(1, 100, cityAddressRegex, 'Invalid City');
exports.cityAddressValidation = cityAddressValidation;
var propertyNameValidation = validate(1, 100, cityAddressRegex, 'Invalid property name');
exports.propertyNameValidation = propertyNameValidation;
var postcodeAddressValidation = validatePostcode(4, postcodeAddressRegex, 'Invalid Postcode');
exports.postcodeAddressValidation = postcodeAddressValidation;
var poBoxValidation = validate(1, 30, poBoxRegex, 'Invalid PO box');
exports.poBoxValidation = poBoxValidation;
var streetTypeValidation = validateSelect("Please select Street type");
exports.streetTypeValidation = streetTypeValidation;
var residentialStatusValidation = validateSelect("Please select residential status");
exports.residentialStatusValidation = residentialStatusValidation;
var postalAddressStyleValidation = validateSelect("Please select postal address type");
exports.postalAddressStyleValidation = postalAddressStyleValidation;
var auStateValidation = validateSelect("Please select State");
exports.auStateValidation = auStateValidation;